import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { translate } from './Translate';
import Icon from './Icon';
import Badge from './Badge';
import { IdentifierSearch } from '../models/configuration/IdentifierSearch';

const SearchWrapper = styled<any, any>('div')`
    ${propStyles};
`;
Badge.rightAlignStyleProps = {
    order: 1,
};
Icon.rightAlignStyleProps = {
    order: 2,
};
SearchWrapper.defaultProps = {
    flex: '1 0 auto',
    display: 'flex',
    order: ['1', '0'],
    alignItems: 'center',
    bgColor: 'white',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    paddingX: 'sm',
    paddingY: 'xs',
    minHeight: '40px',
};

const SearchInput = styled<any, any>('input')`
    ${propStyles};
    &::-ms-clear {
        display: none;
    }
`;

SearchInput.defaultProps = {
    flex: '1 0 auto',
    fontSize: 'inherit',
    fontFamily: 'inherit',
    fontWeight: 'inherit',
    padding: 'sm',
    borderStyle: 'none',
    bgColor: 'inherit',
    outline: 'none',
};

interface Search {
    theme?: any;
    translations?: object;
    total: number;
    search: IdentifierSearch;
    onChange: (e) => void;
    clearSearch: () => void;
}

export const Search: React.SFC<Search> = ({
    theme,
    translations,
    total,
    onChange,
    clearSearch,
    search,
}) => (
    <SearchWrapper {...theme.SearchWrapper}>
        <Icon
            fileName="SearchIcon"
            height="1.6em"
            width="1.6em"
            {...theme.SearchIcon}
        />
        {search.placeholder.badge && search.placeholder.badge.show && (
            <Badge
                marginX="sm"
                {...search.placeholder.badge.align !== 'left' &&
                    Badge.rightAlignStyleProps}
                {...theme.SearchBadge}
            >
                {translate(
                    translations,
                    total === 1
                        ? search.placeholder.badge.format.singular
                        : search.placeholder.badge.format.plural,
                    {
                        total,
                        properties: search.properties.join(', '),
                    }
                )}
            </Badge>
        )}
        <SearchInput
            type="text"
            value={search.value}
            onChange={e => onChange(e.target.value)}
            placeholder={translate(
                translations,
                total === 1
                    ? search.placeholder.format.singular
                    : search.placeholder.format.plural,
                {
                    total,
                    properties: search.properties.join(', '),
                }
            )}
            autoCapitalize="off"
            autoComplete="off"
            spellCheck="false"
            autoCorrect="off"
            {...theme.SearchInput}
        />
        {search.value && (
            <Icon
                fileName="CloseIcon"
                title={translate(translations, 'Clear Search')}
                onClick={clearSearch}
                cursor="pointer"
                height="1.6em"
                width="1.6em"
                {...theme.SearchCloseIcon}
                {...Icon.rightAlignStyleProps}
            />
        )}
    </SearchWrapper>
);

export default inject('translations')(withTheme(observer(Search))) as any;



// WEBPACK FOOTER //
// ./src/Components/Search.tsx